import React from 'react';
import PropTypes from 'prop-types';
import { orderBy } from 'lodash-es';
import { getStaticImageUrl } from 'client/utils/image-helpers';
import { numberWithCommas } from 'site-modules/shared/utils/string';

function getPercentage(partialValue, totalValue) {
  return (100 * partialValue) / totalValue;
}

function StatsRow({ nationalCount, makeName, biggestNationalSalesCount, color }) {
  const makeSlug = makeName.toLowerCase();
  const imgSrc = getStaticImageUrl(`/img/oem-logos/make-logos/${makeSlug}@3x.png`);
  const graphPercentageWidth = `${getPercentage(nationalCount, biggestNationalSalesCount)}%`;

  return (
    <div
      className="stats-row d-flex align-items-center justify-content-between mb-0_5"
      style={{ height: '30px' }}
      aria-live="off"
    >
      <img src={imgSrc} alt={makeName} width={34} aria-live="off" />
      <div className="graph-wrap mx-0_75">
        <div
          className="graph rounded"
          style={{
            width: graphPercentageWidth,
            minWidth: graphPercentageWidth,
            backgroundColor: color,
            height: '16px',
          }}
        />
      </div>
      <span className="small ms-auto">{numberWithCommas(nationalCount)}</span>
    </div>
  );
}

StatsRow.propTypes = {
  nationalCount: PropTypes.number.isRequired,
  makeName: PropTypes.string.isRequired,
  biggestNationalSalesCount: PropTypes.number.isRequired,
  color: PropTypes.string.isRequired,
};

export function NationalStats({ nationalStats, colorsMapping }) {
  const biggestNationalSalesCount = nationalStats.reduce(
    (result, { nationalCount }) => (nationalCount > result ? nationalCount : result),
    0
  );

  return (
    <ol className="national-stats list-unstyled mb-0">
      {orderBy(nationalStats, ['rank'], ['asc']).map(data => (
        <li key={data.rank}>
          <StatsRow
            {...data}
            biggestNationalSalesCount={+biggestNationalSalesCount}
            color={colorsMapping[Object.keys(colorsMapping).find(makeModel => makeModel.includes(data.makeName))]}
          />
        </li>
      ))}
    </ol>
  );
}

NationalStats.propTypes = {
  nationalStats: PropTypes.arrayOf(
    PropTypes.shape({
      makeName: PropTypes.string,
      nationalCount: PropTypes.number,
      rank: PropTypes.number,
      url: PropTypes.string,
    })
  ).isRequired,
  colorsMapping: PropTypes.objectOf(PropTypes.string).isRequired,
};
